<div class="checkbox-wrapper">
  <div class="checkbox-container" [ngClass]="{ 'error': error }">
    <p-checkbox
      [ngModel]="value"
      [binary]="true"
      [ngClass]="size"
      [disabled]="disabled"
      class="custom-checkbox"
      (onChange)="onValueChange($event.checked)"
    ></p-checkbox>
    @if (label) {
      <span class="custom-checkbox-label" [ngClass]="size">{{ label }}</span>
    }
  </div>
  @if (helperText) {
    <span class="helper-text">{{ helperText }}</span>
  }
</div>